import { createSlice } from "@reduxjs/toolkit";

const propertySlice = createSlice({
  name: "property",
  initialState: {
    property: null,
    editingProperty: null,
    propertyList: null,
    availability: null,
  },
  reducers: {
    setProperty: (state, action) => {
      state.property = action.payload
    },
    setPropertyList: (state, action) => {
      state.propertyList = action.payload
    },
    setEditingProperty: (state, action) => {
      state.editingProperty = action.payload
    },
    setAvailability: (state, action) => {
      state.availability = action.payload
    },
  },
});

export const { setProperty, setPropertyList, setEditingProperty, setAvailability } = propertySlice.actions;

export default propertySlice.reducer;

export const selectCurrentProperty = (state) => state.persistedReducer.property?.property ?? null;
export const selectPropertyList = (state) => state.persistedReducer.property?.propertyList ?? null;
export const selectEditingProperty = (state) => state.persistedReducer.property?.editingProperty ?? null;
export const selectAvailability = (state) => state.persistedReducer.property?.availability ?? null;

